import api from "./api";

// Resolve a Country/State/City to its SocialPulse guide record (or null).
export async function fetchGuide({ country = "", state = "", city = "" }) {
  try {
    const { data } = await api.get("/guide/resolve", { params: { country, state, city } });
    const node = city ? data.city : state ? data.state : data.country;
    const slug = typeof node === "string" ? node : node?.slug;
    if (!slug) return null;
    const r = await api.get(`/guide/location/${slug}`);
    return r.data;
  } catch {
    return null;
  }
}
